import React from "react";
import ListItem from "@mui/material/ListItem";
import { ListItemButton, ListItemText, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const NavItem = ({
  labelText,
  to,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const checkActive = (path) => {
    const regex = new RegExp(`${path}(\/.*)?$`);
    return regex.test(location.pathname);
  };

  return (
    <ListItem
      key={labelText}
      sx={{ paddingLeft: 0 }}
    >
      <ListItemButton
        onClick={() => {
          navigate(to);
        }}
        selected={checkActive(to)}
      >
        <Stack
          pl={3}
          pr={2}
        >
          <ListItemText
            primary={labelText}
            primaryTypographyProps={{
              variant: "body1",
              letterSpacing: 0,
            }}
          />
        </Stack>
      </ListItemButton>
    </ListItem>
  );
};

export default NavItem;